import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { UserLogin } from '../../../Common/models/user.login';
import { RoleName } from '../../../Common/Constants/common.constants';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';

@Component({
  selector: 'app-retailhub-adhoc-template',
  templateUrl: './retailhub-adhoc-template.component.html',
  styleUrl: './retailhub-adhoc-template.component.css'
})
export class RetailhubAdhocTemplateComponent implements OnInit {
  onSelectedCategory($event: any) {
    throw new Error('Method not implemented.');
  }

  form!: FormGroup;
  stockingPriorityForm!: FormGroup;
  uInfo: UserLogin | null | undefined;
  public isITAdmin: boolean = false;
  public isSRETeam: boolean = false;
  public isSRESupport: boolean = false;
  public isCustomerSupportTeam: boolean = false;

  categoryList: any[] | undefined = [];
  selectedCategories: any[] = [];

  typeOfRequests: any = [
    { id: 1, name: 'PHOTO REQUEST' },
    { id: 2, name: 'AUDIT QUESTION' },
    { id: 3, name: 'ACTIVITY REQUEST' }
  ];

  constructor(private fb: FormBuilder,
    private userRoleService: UserRoleServiceService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      rows: this.fb.array([this.createRow()])
    });

    this.stockingPriorityForm = this.fb.group({
      stockingPriorityRows: this.fb.array([this.createStockingPriorityRow()])
    });


    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      this.uInfo = JSON.parse(atob(encodedVal));

      let userRoleInfo: UserLogin = this.uInfo!;
      this.isITAdmin = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.ITAdmin);
      this.isSRETeam = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SREAdmin || a.roleName == RoleName.SRESupport) && (a.write == true));
      this.isSRESupport = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SRESupport) && (a.write == false));
      this.isCustomerSupportTeam = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.CustomerTeam);
    }
    this.categoryList = this.userRoleService.role?.roleID == 4 ? this.uInfo!.userCategory : this.uInfo!.categories;
    this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
  }

  get rows(): FormArray {
    return this.form.get('rows') as FormArray;
  }

  get stockingPriorityRows(): FormArray {
    return this.stockingPriorityForm.get('stockingPriorityRows') as FormArray;
  }

  createRow(data?: any): FormGroup {
    return this.fb.group({
      typeOfRequest: [data?.typeOfRequest || ''],
      description: [data?.description || ''],
      responseOption: [data?.responseOption || ''],
      storeNumbers: [data?.storeNumbers || ''],
      image: [data?.image || null]
    });
  }

  createStockingPriorityRow(data?: any): FormGroup {
    return this.fb.group({
      itemNumber: [''],
      // upc: [data?.upc || ''],
      // stockingDescription: [data?.stockingDescription || ''],
      priorityNotes: [''],
    });
  }

  duplicateRow(index: number): void {
    if (this.rows.length >= 5) {
      alert('You can only add up to 5 rows.');
      return;
    }

    const currentRow = this.rows.at(index).value;
    const newRow = this.createRow(currentRow);
    this.rows.insert(index + 1, newRow);
  }

  deleteRow(index: number): void {
    if (this.rows.length <= 1) {
      alert('At least one row must remain.');
      return;
    }

    this.rows.removeAt(index);
  }

  duplicatestockingPriorityRow(index: number): void {
    if (this.stockingPriorityRows.length >= 10) {
      alert('You can only add up to 10 stockingPriorityRows.');
      return;
    }

    const currentRow = this.stockingPriorityRows.at(index).value;
    const newRow = this.createStockingPriorityRow(currentRow);
    this.stockingPriorityRows.insert(index + 1, newRow);
  }

  deletestockingPriorityRow(index: number): void {
    if (this.stockingPriorityRows.length <= 1) {
      alert('At least one row must remain.');
      return;
    }

    this.stockingPriorityRows.removeAt(index);
  }

  exportToExcel() {
    const formArray = this.stockingPriorityForm.get('stockingPriorityRows') as FormArray;

    const dataToExport = formArray.value.map((row: any) => ({
      'ITEM NUMBER': row.itemNumber,
      'NOTE': row.priorityNotes
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

    const headerCells = ['A1', 'B1'];
    headerCells.forEach(cell => {
      if (!worksheet[cell]) return;
      worksheet[cell].s = {
        font: { bold: true }
      };
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Stocking Priority': worksheet },
      SheetNames: ['Stocking Priority']
    };

    XLSX.writeFile(workbook, 'StockingPriority.xlsx');
  }
}
